import React from 'react';
import { Typography } from '@telus-uds/components-web';
import { INLINES } from '@contentful/rich-text-types';

const formFieldOperationOptions = value => {
  return {
    renderNode: {
      [INLINES.EMBEDDED_ENTRY]: (node, key) => {
        if (
          !(
            value &&
            node.data &&
            node.data.target &&
            node.data.target.fields &&
            node.data.target.fields.operationType
          )
        ) {
          return null;
        }
        const { operationType, constantValue } = node.data.target.fields;
        let calculatedValue = 0;
        let inputValue = value || 0;
        if (!Number.isInteger(inputValue)) {
          inputValue = parseInt(inputValue, 10);
        }
        switch (operationType) {
        case 'add':
          calculatedValue = constantValue
            ? inputValue + constantValue
            : inputValue;
          break;
        case 'multiply':
          calculatedValue = constantValue
            ? inputValue * constantValue
            : inputValue;
          break;
        default:
          break;
        }
        return <Typography key={key}>{calculatedValue}</Typography>;
      }
    }
  };
};

export default formFieldOperationOptions;
